module.exports = __webpack_public_path__ + "img/irix_head_logo.46932f7a.svg";